import React from 'react';

const INCLUDES = [
  'The full 4-hour live roadmap session with Chai',
  'Your week-by-week plan for the first ~2 years',
  'Live Q&A — bring your own situation',
  'One-time fee · no cross-selling, no upsell',
];

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <circle cx="9" cy="9" r="9" fill="rgba(40,200,120,0.15)" />
    <path d="M5 9.5l2.8 2.8L13 6" stroke="#3ee09a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function F2FPricing({ pricing }) {
  const current = pricing?.current || '₹999';
  return (
    <section className="f2f-pricing-v2">
      <div className="wrap f2f-pricing-v2-inner">
        <p className="f2f-pricing-eyebrow">One simple price</p>
        <h2 className="f2f-pricing-heading">{current}. Attend, get your plan, done.</h2>
        <p className="f2f-pricing-sub">
          A one-time fee — no cross-selling, no upsell at the end. You come for a roadmap and you leave with one.
        </p>

        <div className="f2f-pricing-card-v2">
          <div className="f2f-price-row">
            <span className="f2f-price">{current}</span>
            <span className="f2f-price-label">one-time</span>
          </div>
          <p className="f2f-price-sub">Full 4-hour session · Sat, Aug 14</p>

          <ul className="f2f-includes-list">
            {INCLUDES.map((item) => (
              <li key={item} className="f2f-includes-item">
                <CheckIcon />
                {item}
              </li>
            ))}
          </ul>

          <div>
            <a className="f2f-payu-link" href="https://u.payu.in/zIrP02aOwb0c">
              Book Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
